import styled from 'styled-components';

export const StyledTalFigurativeWrapper = styled.div`
  width: 1180px;
  margin: 0 auto;

  .refresh-demo {
    cursor: pointer;
    color: #017afe;
    font-size: 14px;

    span {
      margin-left: 5px;
    }
  }

  .demo-content {
    margin-top: 10px;
    zoom: 1;
    height: 540px;

    & > div {
      float: left;
      height: 100%;
      display: inline-block;
      box-sizing: border-box;
      padding: 30px;
      background: #fff;
    }

    .demo-input {
      width: 490px;
      border: 1px solid #ddd;
      color: #999;
      font-size: 16px;
      margin-right: 20px;
      line-height: 1.5;
    }

    .demo-result {
      border: 1px solid #ddd;
      width: 670px;

      .result-title {
        font-size: 20px;
        font-weight: bold;
        color: #390;
      }

      .result-summarize {
        display: flex;
        margin: 20px 0;

        & > div {
          flex: 1;
        }
      }
    }
  }
`;
